module.exports = __webpack_public_path__ + "static/img/bg-cooperate.2707afb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-cooperate.jpg
// module id = iW9Z
// module chunks = 30